import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import {Link} from 'react-router-dom';
import {List, Tabs, Icon, Avatar, Input, Button, message} from 'antd';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {echo, actionFetchArticles, actionFetchFeedInfo, actionSubscribeEmail} from '../utils/service';

const {TabPane} = Tabs;

const Container = styled.div`
  display: flex;
  flex-direction: column;
`

const ArticleContainer = styled.div`
  height: 100px;
  width: 100%;
  display: flex;
`

const ArticleCover = styled.div`
  height: 88px;
  width: 88px;
  flex-basis: 88px;
  flex-shrink: 0;
  background: url(${props => props.source}) center no-repeat;
  background-size: cover;
  border-radius: 3px;
`

const ArticleContent = styled.div`
  flex-grow: 1;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 12px;
`

const ArticleTitle = styled.div`
  flex-grow: 1
  flex-basis: 200px;
`

const ArticleDesc = styled.h4`
  @media(max-width: 700px) {
    display: none;
  }
  color: #acb3c2;
`

const ArticleExtra = styled.span`
  display: block;
  flex-shrink: 0;
  color: #acb3c2;
`

const TabContainer = styled.div`
  display: flex;
  height: 160px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 600px;
  margin:auto;
`

const TabInputContainer = styled.div`
  display:flex;
  width: 100%;
`

const TabTip = styled.p`
  margin-bottom: 20px;
  font-size: 16px;
  color: #acb3c2;
`

const TabTipRed = styled.p`
  margin-top: 12px;
  font-size: 14px;
  color: #32b643;
`

const InputAfter = styled.span`
  cursor: pointer;
`

const ArticleTag = styled.span`
  width: 100%;
  text-align: center;
  color: #acb3c2;
`

export default class ArticleList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      email: '',
      feed: 'Loading...',
    }
  }

  componentDidMount() {
    this.fetchData();
    this.fetchFeedInfo();
  }

  fetchFeedInfo = () => {
    const {biz} = this.props.match.params;
    actionFetchFeedInfo(biz)
      .then(({data}) => {
        this.setState({
          feed: data.data.feed,
        })
      }).catch(err => {
        message.error(`获取RSS地址失败: ${err.message}`)
        this.setState({
          feed: '获取失败，请返回重试',
        })
      })
  }

  fetchData = () => {
    this.setState({
      loading: true,
    })
    const {biz} = this.props.match.params;
    actionFetchArticles(biz)
      .then(({data}) => {
        const result = [{message: '此处隐藏最新的三篇文章，RSS可见'}].concat(data.data);
        this.setState({
          data: result,
          loading: false,
        })
      }).catch(err => {
        message.error(`服务器错误: ${err.message}`)
        this.setState({
          data: [],
          loading: false
        })
      })
  }

  handleSubscribeEmail = () => {
    const email = this.state.email;
    const {biz} = this.props.match.params;
    actionSubscribeEmail({email, biz})
      .then(({data}) => {
        if(data.status == 0)  {
          message.success('订阅成功');
        } else {
          message.error(`订阅失败: ${data.message}`);
        }
      }).catch(err => {
        message.error(`订阅失败: ${err.message}`);
      })
  }

  handleCopy = () => {
    message.success("复制成功");
  }

  renderArticleItem = item => (
    <List.Item>
      <Link to={item.content_url} target="_blank" style={{width:'100%'}}>
        <ArticleContainer>
          <ArticleCover source={`${echo}${encodeURIComponent(item.cover)}`}/>
          <ArticleContent>
            <ArticleTitle>
              <h3 lang="zh-Hans">{item.title}</h3>
              <ArticleDesc className="text-gray" lang="zh-Hans">{item.digest}</ArticleDesc>
            </ArticleTitle>
            <ArticleExtra>{moment.unix(item.datetime).format('L')}</ArticleExtra>
          </ArticleContent>
        </ArticleContainer>
      </Link>
    </List.Item>
  )

  renderItem = item => {
    if (item.content_url) {
      return this.renderArticleItem(item);
    } else {
      return this.renderTagItem(item.message)
    }
  }

  renderTagItem = msg => (
    <List.Item style={{backgroundColor: '#fafafa'}}>
      <ArticleTag lang="zh-Hans" class="text-secondary">{msg}</ArticleTag>
    </List.Item>
  )

  resetEmailInput = () => {
    this.setState({
      email: ''
    });
  }

  renderRSSTab = (feed) => {
    return (
      <TabContainer>
        <TabTip >请复制下面链接到你常用的RSS订阅器</TabTip>
        <TabInputContainer>
          <Input 
          addonAfter={
            <CopyToClipboard text={feed} onCopy={this.handleCopy}><InputAfter><Icon type="copy" /> 复制</InputAfter></CopyToClipboard>
          } 
          value={feed} disabled={true} />
        </TabInputContainer>
        </TabContainer>
      )
  }

  renderEmailTab = () => {
    const {email} = this.state;
    const onChange = (e) => {
      this.setState({
        email: e.target.value,
      })
    }
    return (
      <TabContainer>
        <TabTip>输入你的订阅邮箱</TabTip>
        <TabInputContainer>
          <Input 
            prefix={<Icon type="mail" style={{ color: 'rgba(0,0,0,.25)' }} />}
            value={email}
            placeholder="订阅邮箱"
            suffix={email ? <Icon type="close-circle" style={{ color: 'rgba(0,0,0,.25)' }} onClick={this.resetEmailInput} /> : null}
            onChange={onChange}
          />
          <Button onClick={this.handleSubscribeEmail} type="primary" style={{marginLeft: '10px'}}>订阅</Button>
        </TabInputContainer>
        <TabTipRed lang="zh-Hans">*WIP,可以正常订阅，服务暂未启动</TabTipRed>
      </TabContainer>
    )
  }

  renderAPITab = (biz) => {
    const api = `https://rss.anreader.com/v1/publishers/${biz}/articles`;
    return (
      <TabContainer>
        <TabTip>该API仅供用于测试连通性以及数据结构</TabTip>
        <TabInputContainer>
          <Input addonAfter={<Link to={api} target="_blank" ><InputAfter><Icon type="smile-o" /> 点击测试</InputAfter></Link>} disabled={true} defaultValue={api} />
        </TabInputContainer>
        <TabTipRed lang="zh-Hans">*如需Token请<a class="text-success" href="mailto:anreader.com@gmail.com" style={{color: '#32b643'}}>邮件联系</a></TabTipRed>
      </TabContainer>
    )
  }

  render() {
    const {data, loading = false, feed} = this.state;
    const {biz} = this.props.match.params;
    console.log(biz);
    return (
      <Container>
        <Tabs  size="large">
          <TabPane key='1' tab={<span><Icon type="cloud-o" />RSS订阅</span>}>
            {this.renderRSSTab(feed)}
          </TabPane>
          <TabPane key='2' tab={<span><Icon type='mail'/>邮件订阅</span>}>
            {this.renderEmailTab()}
          </TabPane>
          <TabPane key='3' tab={<span><Icon type="code-o"/>API</span>}>
            {this.renderAPITab(biz)}
          </TabPane>
        </Tabs>
        <List dataSource={data} loading={loading} renderItem={this.renderItem} itemLayout="horizontal" />
      </Container>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/ArticleList.js